import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=54a98017&scoped=true&"
import script from "./privilege.vue?vue&type=script&lang=js&"
export * from "./privilege.vue?vue&type=script&lang=js&"
import style0 from "./privilege.vue?vue&type=style&index=0&id=54a98017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a98017",
  null
  
)

export default component.exports